// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileOfficePdfIconSignature {
  Element: SVGSVGElement;
}

export const FileOfficePdfIcon: TOC<FileOfficePdfIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 3H15V7H19V8H21V5.586L16.414 1H5C3.897 1 3 1.898 3 3V8H5V3ZM19 21H5V20H3V21C3 22.103 3.897 23 5 23H19C20.103 23 21 22.103 21 21V20H19V21ZM9 18V10H11C13.206 10 15 11.794 15 14C15 16.206 13.206 18 11 18H9ZM13 14C13 15.103 12.103 16 11 16V12C12.103 12 13 12.898 13 14ZM22 10V12H18V13H21V15H18V18H16V12C16 10.898 16.897 10 18 10H22ZM4 16H5C6.654 16 8 14.654 8 13C8 11.346 6.654 10 5 10H2V18H4V16ZM5 12H4V14H5C5.551 14 6 13.552 6 13C6 12.448 5.551 12 5 12Z"/>
</svg>
</template>;